import React from 'react';
import { ScrapbookFile } from '@/api';

interface ColourPaletteProps {
  content: {
    name: string;
    colours: Array<{
      id: string;
      hexCode: string;
      displayName?: string;
      tpxCode?: string;
      ralCode?: string;
      coatedCode?: string;
      ncsCode?: string;
      effect?: string;
    }>;
    pageId?: string;
    pageUrl?: string;
  };
  file: ScrapbookFile;
  selected?: boolean;
  onSelect?: () => void;
  viewMode?: 'grid' | 'list';
}

const ColourPalette: React.FC<ColourPaletteProps> = ({
  content,
  file,
  selected = false,
  onSelect,
  viewMode = 'grid',
}) => {
  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString();
  };

  const itemClassName = `item ${selected ? 'sel' : 'unsel'}`;

  if (viewMode === 'list') {
    return (
      <>
        <div className="flex h-[160px] items-center gap-4 border border-gray-200 bg-white">
          <div
            className="h-full w-[315px] cursor-pointer border-r border-gray-300 bg-gray-50 px-[21px] py-0"
            // onClick={openPreview}
          >
            <div className="flex h-full w-full flex-row items-stretch">
              {content.colours.map((colour) => (
                <div key={colour.id} className="h-full flex-1" style={{ backgroundColor: `#${colour.hexCode}` }} />
              ))}
            </div>
          </div>
          <div
            className="relative bottom-10 flex-1 cursor-pointer"
            // onClick={openPreview}
          >
            <h4 className="font-bold text-gray-900">{content.name}</h4>
            <div className="mt-1 text-xs text-black">
              <div className="line-clamp-3 overflow-hidden">Saved on {formatDate(file.lastModified || '')}</div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div draggable className="draggable-item">
        <div className={itemClassName}>
          <div className="selTick" onClick={onSelect}></div>
          <div className="cmp">
            <div
              className="cntr relative h-0 w-full cursor-pointer overflow-hidden border border-b-0 border-gray-300 bg-white pt-[30px]"
              style={{ paddingBottom: '73.25%' }}
              // onClick={openPreview}
            >
              <div className="absolute top-0 left-0 flex h-full w-full flex-row items-stretch">
                {content.colours.map((colour) => (
                  <div key={colour.id} className="h-full flex-1" style={{ backgroundColor: `#${colour.hexCode}` }} />
                ))}
              </div>
            </div>
            <div
              className="ifno relative h-[120px] cursor-pointer border border-gray-300 bg-white p-3 text-sm"
              //   onClick={openPreview}
            >
              <div className="reportTitle">
                <h4 className="font-bold">{content.name}</h4>
                <div className="lnk mt-1 text-xs">
                  <div className="line-clamp-3 overflow-hidden">Saved on {formatDate(file.lastModified || '')}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ColourPalette;
